import isUndefined from 'lodash.isundefined';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';

// components
import { BodyMedium } from '@styled';

// functionality
import { CartItemEventContext } from './CartItemEventProvider';
import { formatMoney } from '@general/helpers/currency.helpers';
import colors from '@general/colors';
import useEventFromAPI from '@hooks/apiLegacy/useEventFromAPI';
import useEventPrices from '@hooks/useEventPrices';

const FullPriceTextStyled = styled(BodyMedium)`
    color: ${colors.mediumGray};
    margin-right: 10px;
    text-decoration: line-through;
`;

const CartItemEventPrices = ({ onComponentLoaded = () => {} }) => {
    const [registeredPrice, setRegisteredPrice] = useState(null);
    const { eventDataForMember } = useContext(CartItemEventContext);
    const { event: eventFromAPI } = useEventFromAPI({ code: eventDataForMember.code });
    const { nonMemberPrice } = useEventPrices({ eventCode: eventDataForMember.code });

    useEffect(() => {
        if (!eventDataForMember) {
            return;
        }

        const registeredFee = eventDataForMember.sessions.find(
            session => session.meta_info?.event_function_code === 'FP'
        );

        if (registeredFee) {
            setRegisteredPrice(registeredFee?.price);
        }
    }, [eventDataForMember]);

    if (isUndefined(registeredPrice) && !eventDataForMember.sessionsOnly) {
        return null;
    }

    return (
        <div className="flex">
            {!eventDataForMember.sessionsOnly && !eventDataForMember.optionalFullProgram && (
                <>
                    {nonMemberPrice && nonMemberPrice !== registeredPrice && registeredPrice > 0 && (
                        <FullPriceTextStyled>{formatMoney(nonMemberPrice, eventFromAPI.locale)}</FullPriceTextStyled>
                    )}

                    {registeredPrice !== null && (
                        <BodyMedium>{formatMoney(registeredPrice, eventFromAPI.locale)}</BodyMedium>
                    )}
                </>
            )}

            {eventDataForMember.sessionsOnly && eventDataForMember.registered && <BodyMedium>Registered</BodyMedium>}
        </div>
    );
};

CartItemEventPrices.propTypes = {
    onComponentLoaded: PropTypes.func,
};

export default CartItemEventPrices;
